import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(`${API}/promo-banner`);
        if (response.data?.enabled) setBanner(response.data);
      } catch (error) {}
    };
    fetchBanner();
  }, []);

  if (!banner) return null;

  return (
    <div className="bg-charcoal text-cream text-center py-2 text-xs md:text-sm tracking-wide" data-testid="promo-banner">
      <span className="text-terracotta font-medium">{banner.text}</span>
    </div>
  );
};
